import * as Api from '@api';
import clsx from 'clsx';
import React from 'react';
import { LayoutMargins, LayoutMaxWidth, marginsClassMSL, maxWidthClass, MediaSpecific } from '../Layout';
import { Color, colorProps, Typography, typographyClass } from '../Typography';
import css from './page.module.scss';

export interface PageContentLayout extends LayoutMaxWidth, LayoutMargins { }

export interface PageContentProps extends Api.ContentItem, PageContentLayout
{
    centered?: boolean;
    mobileCentered?: boolean;
    className?: string;
    hasLinks?: boolean;
    layout?: MediaSpecific<PageContentLayout>;
    style?: React.CSSProperties;
    textColor?: Color | string;
    typography?: Typography;
    uppercase?: boolean;
    id?: string;
}

export const PageContent = ({ centered, mobileCentered, className, data, hasLinks = true, layout, margins, maxWidth, textColor, style, type, typography, uppercase, ...otherProps }: PageContentProps): React.FunctionComponentElement<PageContentProps> =>
{
    const { className: textColorClass, style: textColorStyle } = colorProps(textColor);
    const expTM = /Click™/i;
    let dataContent = data;
    const isMainTitle = expTM.test(dataContent);
    if (isMainTitle && typography === Typography.H1) {
        dataContent = dataContent.replace(expTM, 'Click<sup class="supTM">™</sup>');
    }

    const combinedLayout: MediaSpecific<PageContentLayout> = {
        ...layout,
        all: {
            ...layout?.all,
            ...{
                margins: layout?.all?.margins ?? margins,
                maxWidth: layout?.all?.maxWidth ?? maxWidth,
            }
        },
        mobile: {
            ...layout?.mobile,
            ...{
                margins: layout?.mobile?.margins ?? margins,
                maxWidth: layout?.mobile?.maxWidth ?? maxWidth,
            }
        },
        ipad: {
            ...layout?.ipad,
            ...{
                margins: layout?.ipad?.margins ?? margins,
                maxWidth: layout?.ipad?.maxWidth ?? maxWidth,
            }
        },
        desktop: {
            ...layout?.desktop,
            ...{
                margins: layout?.desktop?.margins ?? margins,
                maxWidth: layout?.desktop?.maxWidth ?? maxWidth,
            }
        }
    };

    const props = {
        ...otherProps,
        className: clsx(
            typographyClass(typography),
            marginsClassMSL(combinedLayout),
            maxWidthClass(combinedLayout),
            {
                [css["content--centered"]]: centered,
                [css["content--centered--mobile"]]: mobileCentered,
                [css["content--has-links"]]: hasLinks,
                [css["content--uppercase"]]: uppercase
            },
            textColorClass,
            className,
        ),
        style: {
            ...textColorStyle,
            ...style,
        },
    };

    return type === Api.ContentType.Html ?
        <div {...props} dangerouslySetInnerHTML={{ __html: dataContent }} />
        :
        typography === Typography.H1 ? isMainTitle && typography === Typography.H1 ? <h1 {...props} dangerouslySetInnerHTML={{__html: dataContent}}></h1> :<h1 {...props}>{dataContent}</h1> :
            typography === Typography.H2 ? <h2 {...props}>{dataContent}</h2> :
                typography === Typography.H3 ? <h3 {...props}>{dataContent}</h3> :
                    typography === Typography.H4 ? <h4 {...props}>{dataContent}</h4> :
                        typography === Typography.H5 ? <h5 {...props}>{dataContent}</h5> :
                            typography === Typography.H6 ? <h6 {...props}>{dataContent}</h6> :
                                <p {...props}>{dataContent}</p>;
}